import { PAGEBUILDER_GENERAL_UPDATE_CUSTOM_CODE_SETTINGS } from '../reducers/builder/configReducer/actions';
import { ICustomCodePayload } from '../utils/interfaces';

export const updateCustomCodeGeneralSettings = (payload: ICustomCodePayload) => ({
  type: PAGEBUILDER_GENERAL_UPDATE_CUSTOM_CODE_SETTINGS,
  payload
});
